<template>
  <h2>Error 404</h2>
  <p>j00 4r3 n00b pwn3d</p>
  <p>
    <router-link to="/">Back to Home</router-link>
  </p>
</template>